class Inventory {

	/**
	 * The list of files
	 * 
	 * @var {Object}
	 */
	list = [];

	/**
	 * The list of suffixes to prevent
	 * 
	 * @var {Object}
	 */
	suffixes = [];

	/**
	 * Prevent duplicate queries for list
	 * 
	 * @var {bool}
	 */
	#hasFetchedList = false;

	/**
	 * Prevent duplicate queries for suffixes
	 * 
	 * @var {bool}
	 */
	#hasFetchedSuffixes = false;

	/**
	 * Construct the class
	 * 
	 * @return {Void}
	 */
	constructor() {
		//
	}
	
	/**
	 * Get the list of files
	 * 
	 * @return {Object}
	 */
	get list() {
		return this.list;
	}

	/**
	 * Get the list of files that should not have suffixes
	 * 
	 * @return {Object}
	 */
	get suffixes() {		
		return this.suffixes;
	}

	/**
	 * Fetch the all the inventories lists
	 * 
	 * @return {Promise}
	 */
	fetchList = async () => {
		if (this.#hasFetchedList === false) {
			this.list = await $.getJSON(`/inventory/list`);
			this.#hasFetchedList = true;
		}

		return this.list;
	}

	/**
	 * Fetch the all the inventories lists
	 * 
	 * @return {Promise}
	 */
	fetchListSuffixes = async () => {
		if (this.#hasFetchedSuffixes === false) {
			this.suffixes = await $.getJSON(`/inventory/suffixes`);
			this.#hasFetchedSuffixes = true;
		}

		return this.suffixes;
	}

	/**
	 * Return true if the file is found in the list.
	 * 
	 * @param {string} version The Oracle version
	 * @param {string} module The module name
	 * @param {string} basename The basename of the file
	 * 
	 * @return {Promise}
	 */
	has = async (version, module, basename) => {
		// Populate the lists
		await this.fetchListSuffixes().catch((err) => { console.error(err) });
		await this.fetchList().catch((err) => { console.error(err) });

		// for local
		// return true;

		if (['xls', 'xlsx'].includes(basename.split('.').pop().toLowerCase())) {
			try {
				let filename = basename.substring(0, basename.indexOf('.'));
				let countSuffixes = basename.split('.').length - 2;
				// If the file is FBDI or HDL and has suffxes, this is forbidden
				if (this.suffixes.includes(filename) && countSuffixes) return false;
				// Otherwise check if in the list of files
				return this.list[version][module].includes(filename);
			} catch (err) {
				console.error(`${basename} (${version} ${module}): ${err}`);
			}
		}
		
		return false;
	}
}

export { Inventory };